import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import { VehiclesService } from "@services";
import utils from "@utils";
import { Modal, ConfirmationModal } from "../../../../components";
import "./EditVehicleModal.scss";

const EditVehicleModal = props => {
	const { lang } = global;
	const { vehicle, show, onHide, onSuccess } = props;
	const [form, setForm] = useState(vehicle ? { ...vehicle } : { Number: "" });

	const _confirmationModal = useRef(null);

	useEffect(() => {
		setForm(vehicle ? { ...vehicle } : { Number: "" });
	}, [vehicle]);

	const saveVehicle = () => {
		if (!form.Number) {
			return;
		}

		if (vehicle) {
			VehiclesService.update(vehicle.Id, { ...vehicle, Number: form.Number })
				.then(() => {
					utils.notify({
						type: "success",
						message: lang.t("Vehicle updated successfully"),
						timeOut: 1500,
					});
					setForm({ Number: "" });
					onSuccess();
					onHide();
				})
				.catch(({ response }) =>
					utils.notify({
						type: "error",
						message: response?.data?.Message ?? lang.t("Error updating vehicle"),
						timeOut: 1500,
					}),
				);
		} else {
			VehiclesService.create(form)
				.then(() => {
					utils.notify({
						type: "success",
						message: lang.t("Vehicle created successfully"),
						timeOut: 1500,
					});
					setForm({ Number: "" });
					onSuccess();
					onHide();
				})
				.catch(({ response }) => {
					utils.notify({
						type: "error",
						message: response?.data?.Message ?? lang.t("Error creating vehicle"),
						timeOut: 1500,
					});
				});
		}
	};

	const onInputChange = (field, value) => {
		setForm({
			...form,
			[field]: value,
		});
	};

	return (
		<>
			<Modal
				id="edit-vehicle-modal"
				dialogClassName="edit-vehicle-dialog"
				size="xs"
				show={show}
				onHide={() => onHide()}
			>
				<Modal.Header
					closeButton
					className="hidden-print"
				>
					<Modal.Title>
						{vehicle ? lang.t("Edit Vehicle") : lang.t("Add Vehicle")}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body className="container-fluid">
					<div className="row">
						<div className="col-xs-12">
							<label htmlFor="vehicleNumber">{lang.t("Number")}</label>
						</div>
						<div className="col-xs-12">
							<input
								className="form-control"
								id="vehicleNumber"
								name="vehicleNumber"
								value={form.Number}
								maxLength={30}
								onChange={e => onInputChange("Number", e.target.value)}
							/>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button
						id="button-go-back"
						className="btn btn-link hidden-print"
						type="button"
						onClick={() => onHide()}
					>
						{lang.t("Close")}
					</button>
					<button
						type="button"
						id="save-vehicle"
						className="btn btn-primary"
						onClick={() => saveVehicle()}
						disabled={!form.Number || form.Number === vehicle?.Number}
					>
						{`${lang.t("Save")}`}
					</button>
				</Modal.Footer>
			</Modal>
			<ConfirmationModal ref={_confirmationModal} />
		</>
	);
};

EditVehicleModal.propTypes = {
	vehicle: PropTypes.object,
	show: PropTypes.bool,
	onHide: PropTypes.func,
	onSuccess: PropTypes.func,
};

EditVehicleModal.defaultProps = {
	vehicle: null,
	show: false,
	onHide: () => {},
	onSuccess: () => {},
};

export default EditVehicleModal;
